const a = [
  {
    name: "Afterglow",
    category: "serif",
    file: "afterglow",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Amsterdam",
    category: "handwriting",
    file: "amsterdam-one",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Arial Black",
    category: "sans-serif",
    file: "arial-black",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Arima Madurai",
    category: "sans-serif",
    file: "arima-madurai",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Arizonia",
    category: "handwriting",
    file: "arizonia",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Athelas",
    category: "serif",
    file: "athelas",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Autography",
    category: "handwriting",
    file: "autography",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "ITC Avant Garde Gothic",
    displayName: "Avant Garde Gothic",
    fallback: ["Avant Garde Gothic"],
    category: "sans-serif",
    file: "avant-garde-gothic",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Avenir",
    category: "sans-serif",
    file: "avenir",
    format: "ttf",
    weights: ["regular"]
  },
  /**
   * Avenir ships two different regular-weight (400) designs, Book and Roman
   * (Roman's italic is "Oblique"). Roman is its own catalog family so both
   * designs keep their own files instead of fighting over one weight slot.
   * Its files embed the family name "Avenir" (a documented exception in the
   * provenance test). Hidden from the picker; kept for content that uses it.
   */
  {
    name: "Avenir Roman",
    category: "sans-serif",
    file: "avenir-roman",
    format: "ttf",
    weights: ["regular", "italic"]
  },
  {
    name: "Baskerville",
    category: "serif",
    file: "baskerville",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Believe it",
    displayName: "Believe It",
    fallback: ["Believe It"],
    category: "handwriting",
    file: "believe-it",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Belluga Solid Alt",
    displayName: "Belluga",
    fallback: ["Belluga"],
    category: "handwriting",
    file: "belluga",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Bitter",
    category: "serif",
    file: "bitter",
    format: "ttf",
    weights: ["regular", "italic", "bold"]
  },
  {
    name: "Bodega Script",
    category: "handwriting",
    file: "bodega-script",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Book Antiqua",
    category: "serif",
    file: "book-antiqua",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Bookman Old Style",
    category: "serif",
    file: "bookman-old-style",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Boulevard",
    category: "handwriting",
    file: "boulevard",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Brighton Light",
    category: "serif",
    file: "brighton-light-plain",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Brush Script MT",
    displayName: "Brush Script",
    fallback: ["Brush Script"],
    category: "handwriting",
    file: "brush-script",
    format: "ttf",
    weights: ["italic"]
  },
  {
    name: "Bullpen",
    category: "display",
    file: "bullpen",
    format: "ttf",
    weights: ["italic"]
  },
  {
    name: "Carpenter",
    category: "handwriting",
    file: "carpenter",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Caslon 3",
    displayName: "Caslon",
    fallback: ["Caslon"],
    category: "serif",
    file: "caslon",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Centaur",
    category: "serif",
    file: "centaur",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Century Gothic",
    category: "sans-serif",
    file: "century-gothic",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Charm",
    category: "handwriting",
    file: "charm",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Cochin",
    category: "serif",
    file: "cochin",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "CopperPlate",
    displayName: "Copper Plate",
    fallback: ["Copper Plate"],
    category: "serif",
    file: "copper-plate",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Cormorant",
    category: "serif",
    file: "cormorant",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Cormorant Infant",
    category: "serif",
    file: "cormorant-infant",
    format: "ttf",
    weights: ["regular", "italic"]
  },
  {
    name: "Coronet CG",
    displayName: "Coronet",
    fallback: ["Coronet"],
    category: "handwriting",
    file: "coronet-cg",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Dancing Script",
    category: "handwriting",
    file: "dancing-script",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "DIN Condensed",
    displayName: "DIN",
    fallback: ["DIN"],
    category: "sans-serif",
    file: "din-condensed",
    format: "ttf",
    weights: ["bold"]
  },
  {
    name: "Duende",
    category: "handwriting",
    file: "duende",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "English157 BT",
    displayName: "English",
    fallback: ["English"],
    category: "handwriting",
    file: "english-157",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Felix Titling MT",
    displayName: "Felix Titling",
    fallback: ["Felix Titling"],
    category: "serif",
    file: "felix-titling",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "FG Jayne Print",
    category: "handwriting",
    file: "fg-jayne-print",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "FuturTBol",
    displayName: "Futura",
    fallback: ["Futura"],
    category: "sans-serif",
    file: "futura",
    format: "ttf",
    weights: ["bold"]
  },
  {
    name: "Gaeilge",
    category: "display",
    file: "gaeilge",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Gloucester MT Extra Condensed",
    displayName: "Gloucester",
    fallback: ["Gloucester"],
    category: "serif",
    file: "gloucester-mt-extra-condensed",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Gotham",
    category: "sans-serif",
    file: "gotham",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Gotham XNarrow",
    displayName: "Gotham XNarrow Book",
    fallback: ["Gotham XNarrow Book"],
    category: "sans-serif",
    file: "gotham-xnarrow-book",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "GoudyCatalog BT",
    displayName: "Goudy Catalog",
    fallback: ["Goudy Catalog"],
    category: "serif",
    file: "goudy-catalog",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Goudy Old Style",
    category: "serif",
    file: "goudy-old-style",
    format: "ttf",
    weights: ["regular", "italic", "bold"]
  },
  {
    name: "Helvetica Neue",
    category: "sans-serif",
    file: "helvetica-neue",
    format: "ttf",
    weights: ["regular"]
  },
  /**
   * The condensed (narrow) Helvetica Neue faces are a different width, not
   * extra weights of Helvetica Neue, so they are their own catalog family.
   * Their files embed the family name "Helvetica Neue" (a documented
   * exception in the provenance test). Hidden from the picker; kept for
   * content that uses it.
   */
  {
    name: "Helvetica Neue Condensed",
    category: "sans-serif",
    file: "helvetica-neue-condensed",
    format: "ttf",
    weights: ["bold", "900"]
  },
  {
    name: "Kalam",
    category: "handwriting",
    file: "kalam",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Lato",
    category: "sans-serif",
    file: "lato",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Liberty BT",
    displayName: "Liberty",
    fallback: ["Liberty"],
    category: "handwriting",
    file: "liberty",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Lobster Two",
    category: "display",
    file: "lobster-two",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Lora",
    category: "serif",
    file: "lora",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Merienda",
    category: "handwriting",
    file: "merienda",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Minion Pro",
    displayName: "Minion",
    fallback: ["Minion"],
    category: "serif",
    file: "minion-pro",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Mistral",
    category: "handwriting",
    file: "mistral",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Monotype Corsiva",
    category: "handwriting",
    file: "monotype-corsiva",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Monterey BT",
    displayName: "Monterey",
    fallback: ["Monterey"],
    category: "handwriting",
    file: "monterey",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "MurrayHill Bd BT",
    displayName: "Murray Hill",
    fallback: ["Murray Hill"],
    category: "handwriting",
    file: "murray-hill",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "ITC New Baskerville",
    displayName: "New Baskerville",
    fallback: ["New Baskerville"],
    category: "serif",
    file: "new-baskerville",
    format: "ttf",
    weights: ["bold"]
  },
  {
    name: "Nimbus Sans P",
    displayName: "Nimbus",
    fallback: ["Nimbus"],
    category: "sans-serif",
    file: "nimbus-san-p-blac-cond",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Nuptial BT",
    displayName: "Nuptial",
    fallback: ["Nuptial"],
    category: "handwriting",
    file: "nuptial",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Oleo Script",
    category: "display",
    file: "oleo-script",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Omega Sans",
    displayName: "Omega",
    fallback: ["Omega"],
    category: "sans-serif",
    file: "omega-sans",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "OPTILatin-Elongated",
    category: "serif",
    file: "opti-latin-elongated",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Otamendi",
    category: "handwriting",
    file: "otamendi",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Papyrus",
    category: "display",
    file: "papyrus",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "ParkAvenue BT",
    displayName: "Park Avenue",
    fallback: ["Park Avenue"],
    category: "handwriting",
    file: "park-avenue",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Perpetua",
    category: "serif",
    file: "perpetua",
    format: "ttf",
    weights: ["regular", "bold", "italic"]
  },
  {
    name: "Perpetua Titling MT",
    displayName: "Perpetua Titling",
    fallback: ["Perpetua Titling"],
    category: "serif",
    file: "perpetua-titling-mt",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  {
    name: "Piranesi It BT",
    displayName: "Piranesi It",
    fallback: ["Piranesi It"],
    category: "handwriting",
    file: "piranesi-it",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Pristina",
    category: "handwriting",
    file: "pristina",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Ribbon131 BT",
    displayName: "Ribbon",
    fallback: ["Ribbon"],
    category: "handwriting",
    file: "ribbon-131",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Ruthie",
    category: "handwriting",
    file: "ruthie",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Scriptina",
    category: "handwriting",
    file: "scriptina",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "SF Collegiate Solid",
    displayName: "SF Collegiate",
    fallback: ["SF Collegiate"],
    category: "display",
    file: "sf-collegiate-solid",
    format: "ttf",
    weights: ["bold"]
  },
  {
    name: "Shelley Allegro",
    category: "handwriting",
    file: "shelley-allegro",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Shelley Andante",
    category: "handwriting",
    file: "shelley-andante",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "Tangerine",
    category: "handwriting",
    file: "tangerine",
    format: "ttf",
    weights: ["regular", "bold"]
  },
  /**
   * Production's own Times New Roman files (`times-new-roman-*.ttf`), restored
   * so stored text prints with production's letter widths and line breaks.
   * A licensed font with no license on record (#2807): customer PDFs embed
   * these files, as they did before the Lotus release. All four faces are
   * served, real bold included, as production served them. The bold italic is
   * Apple's Times Bold Italic, whose embedding flags say Restricted License,
   * so the manifest extractor refuses it and it has no font record; the page
   * still serves it. The regular and bold lack é, ñ, ü, ç and €; `fallback`
   * puts 'Times' after the name in the stack the TinyMCE font menu applies, as
   * production's menu did, so in TinyMCE those letters draw from production's
   * Times. A Lotus run's stack does not take `fallback`, so a Lotus run draws
   * them from its Latin fallback. The face map also reads fallback
   * names as spellings of this family, and the 'Times' entry below, read
   * after this one, keeps that spelling on its own files.
   */
  {
    name: "Times New Roman",
    fallback: ["Times"],
    category: "serif",
    file: "times-new-roman",
    format: "ttf",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  /**
   * Production's Times: Apple's Times-Roman (`times-regular.ttf`), the face
   * production's browser drew out of the Apple Times collection. Only that
   * face is served, so bold and italic are synthesized from it as production
   * synthesized them. A licensed font with no license on record (#2807).
   */
  {
    name: "Times",
    category: "serif",
    file: "times",
    format: "ttf",
    weights: ["regular"]
  },
  /**
   * The name remaps onto Google's metric-compatible open-source fonts:
   * 'Arial' onto Arimo's files and 'Courier New' onto Cousine's.
   * `assets/css/fonts.css` already renders stored content in these names
   * through those files; the catalog entries make them real families for
   * every lookup (the alias table maps them to Arimo / Cousine, whose
   * records the manifest carries). Hidden from the picker, which offers
   * Arimo and Cousine themselves.
   */
  {
    name: "Arial",
    category: "sans-serif",
    file: "arimo",
    format: "woff2",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Courier New",
    category: "monospace",
    file: "cousine",
    format: "woff2",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  /**
   * Stand-ins for operating-system font names that stored stacks use but no
   * bundled file carries, pointed at metric-compatible open twins in the
   * corpus the same way: 'Georgia' onto Gelasio's files, 'Helvetica' onto
   * Arimo's and 'Calibri' onto Carlito's. Without them the viewer's machine,
   * or the render container, draws these names with whatever font it has.
   * Gelasio draws few Greek letters and no Cyrillic, so `assets/css/fonts.css`
   * serves Georgia's Greek and Cyrillic ranges from Tinos's files, and
   * Georgia keeps its own name in stored styling (`keepsOwnName`): a save
   * that stored Gelasio would paint Gelasio's own faces, without those
   * ranges. Arimo and Carlito cover Greek and Cyrillic themselves, so
   * Helvetica and Calibri alias to them as Arial does to Arimo.
   * The names come from a census of the font-family values stored in saved
   * pages, where Georgia is by far the most common name no `@font-face`
   * declares, then Helvetica. The census's other operating-system names (Big
   * Caslon, Aptos, and the emoji and symbol fonts Apple Color Emoji, Segoe UI
   * Emoji and Segoe UI Symbol) have no metric-compatible twin in the corpus,
   * so no entry names them. Hidden from the picker.
   */
  {
    name: "Georgia",
    category: "serif",
    file: "gelasio",
    keepsOwnName: !0,
    format: "woff2",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Helvetica",
    category: "sans-serif",
    file: "arimo",
    format: "woff2",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Calibri",
    category: "sans-serif",
    file: "carlito",
    format: "woff2",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  {
    name: "Trajan Pro",
    displayName: "Trajan",
    fallback: ["Trajan"],
    category: "serif",
    file: "trajan-pro",
    format: "otf",
    weights: ["regular", "bold"]
  },
  {
    name: "Vivaldi",
    category: "handwriting",
    file: "vivaldi",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "WeddingText BT",
    displayName: "Wedding Text",
    fallback: ["Wedding Text"],
    category: "display",
    file: "wedding-text",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "White Oleander Slanted Alt1",
    displayName: "White Oleander",
    fallback: ["White Oleander"],
    category: "handwriting",
    file: "white-oleander-slanted-alt-1",
    format: "ttf",
    weights: ["regular"]
  },
  {
    name: "YanaR",
    displayName: "Yana",
    fallback: ["Yana"],
    category: "serif",
    file: "yana",
    format: "otf",
    weights: ["regular"]
  },
  {
    name: "Abyssinica SIL",
    category: "serif",
    file: "abyssinica-sil",
    format: "ttf",
    language: "Amharic - አማርኛ",
    weights: ["regular"]
  },
  {
    name: "David Libre",
    category: "serif",
    file: "david-libre",
    format: "ttf",
    language: "Hebrew עברית",
    weights: ["regular", "bold"]
  },
  {
    name: "Frank Ruhl Libre",
    category: "serif",
    file: "frank-ruhl-libre",
    format: "ttf",
    language: "Hebrew - עברית",
    weights: ["regular", "bold"]
  },
  {
    name: "Heebo",
    category: "sans-serif",
    file: "heebo",
    format: "ttf",
    language: "Hebrew - עברית",
    weights: ["regular", "bold"]
  },
  {
    name: "Mirza",
    category: "serif",
    file: "mirza",
    format: "ttf",
    language: "Arabic - عربى",
    weights: ["regular", "bold"]
  },
  {
    name: "Noto Sans KR",
    category: "sans-serif",
    file: "noto-sans-kr",
    format: "otf",
    language: "Korean - 한국어",
    weights: ["regular", "bold"]
  },
  {
    name: "Noto Serif SC",
    category: "serif",
    file: "noto-serif-sc",
    format: "otf",
    language: "Simplified Chinese - 中文",
    weights: ["regular", "bold"]
  },
  {
    name: "Noto Serif TC",
    category: "serif",
    file: "noto-serif-tc",
    format: "otf",
    language: "Traditional Chinese - 中文",
    weights: ["regular", "bold"]
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    file: "open-sans",
    format: "ttf",
    language: "Vietnamese - Tiếng Việt",
    weights: ["regular", "italic", "bold", "bolditalic"]
  },
  /**
   * Generated by `scripts/fonts/subset-cjk-ext.py` (`fonts:cjk-ext`), not a
   * hand-dropped file: a tiny subset of the full open-source (SIL OFL) Noto
   * Sans CJK holding only the rare Chinese/Japanese/Korean characters that
   * the Google web builds of Noto CJK leave out. Reached through fallback
   * (the PDF container's system fonts), never picked — PICKER_EXCLUDED_FONTS.
   */
  {
    name: "Noto Sans CJK Ext",
    category: "sans-serif",
    file: "noto-sans-cjk-ext",
    format: "otf",
    weights: ["regular", "bold"]
  }
];
export {
  a as f
};
